import React from "react";
import { StyleSheet, View } from "react-native";
import CompleteRegistration from "@components/CompleteRegistration";
import PaymentRecieved from "@components/paymentRecieved";
import PaymentRefunded from "@components/PaymentRefunded";

export const LEADER_STATES = {
  PAYMENT_DONE: "PAYMENT_DONE",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  PAYMENT_REFUNDED: "PAYMENT_REFUNDED",
  APPROVED: "APPROVED",
  ZERO_PAYMENT: "ZERO_PAYMENT",
};

const ClPaymentAndAddress = ({ user = {} }) => {
  if (
    user.leader_state === LEADER_STATES.PAYMENT_DONE ||
    user.leader_state === LEADER_STATES.ZERO_PAYMENT
  ) {
    return <PaymentRecieved user={user} />;
  }
  if (user.leader_state === LEADER_STATES.PAYMENT_PENDING) {
    return <CompleteRegistration />;
  }
  if (user.leader_state === LEADER_STATES.PAYMENT_REFUNDED) {
    return <PaymentRefunded leader_state={user.leader_state} />;
  }
  if (user.leader_state === LEADER_STATES.APPROVED) {
    return <PaymentRecieved user={user} />;
  }
  return null;
};

const styles = StyleSheet.create({});

export default ClPaymentAndAddress;
